module.exports = __webpack_public_path__ + "static/media/footer_bg.d5e4d68b.png";